import { getClient } from '@api/client';
import { graphql } from '@api/generated';

import extractErrorMessage from '../../../lib/utils/extractErrorMessage';
import { InteractionUpsertInput } from '@api/generated/graphql';

export const UPSERT_INTERACTION_BY_CHANNEL_ID_MUTATION = graphql(`
  mutation upsertInteractionByChannelId(
    $channelId: ID!
    $input: InteractionUpsertInput!
  ) {
    upsertInteractionByChannelId(channelId: $channelId, input: $input) {
      id
      status
      contactCenter {
        id
        name
      }
    }
  }
`);

async function updateInteractionByChannelId(
  channelId: string,
  tenantId: string,
  input: InteractionUpsertInput,
) {
  try {
    const { data } = await getClient().mutate({
      mutation: UPSERT_INTERACTION_BY_CHANNEL_ID_MUTATION,
      variables: { channelId, tenantId, input },
    });

    if (!data?.upsertInteractionByChannelId) {
      throw new Error('No data');
    }

    return data.upsertInteractionByChannelId;
  } catch (err) {
    throw new Error(extractErrorMessage(err));
  }
}

export default updateInteractionByChannelId;
